import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';

/**
 * SP-54 (Car Comments), 2026-10-28: comments on a Registry car page are its Forum thread.
 *
 * 1. Sign-in and registration stay the Forum's. A car page sends a visitor to
 *    /forum/?citregReturn=/gallery/car.php?id=N (plus &citregSignup=1 for "Register"); this opens the Forum's own
 *    modal and, once signed in, goes back to the car page. LogInModal reloads the page after a successful sign-in
 *    (same as discussionStart.js relies on), so the query string is left in place until the visitor is signed in.
 *    Only /gallery/ paths on this site are accepted as a return address.
 * 2. A car's thread (citregCarId) shows a link back to the car page in its sidebar.
 */
function citregReturnPath() {
  const params = new URLSearchParams(window.location.search);
  const path = params.get('citregReturn') || '';
  return /^\/gallery\/\S*$/.test(path) ? path : null;
}

export function resumeCarReturn() {
  const path = citregReturnPath();
  if (!path) return;

  if (app.session.user) {
    window.location.replace(path);
    return;
  }

  const signup = new URLSearchParams(window.location.search).has('citregSignup');
  app.modal.show(signup ? SignUpModal : LogInModal);
}

export function installCarThreadLink() {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const carId = this.discussion && this.discussion.attribute('citregCarId');
    if (!carId) return;

    items.add(
      'citregCar',
      <a className="Button Button--block citreg-car-link" href={`/gallery/car.php?id=${carId}`}>
        {app.translator.trans('citreg-taxonomy.forum.car_thread.view_car')}
      </a>,
      110
    );
  });
}
